<template>
  <modal id="invite-collaborators-modal" ref="modalWrapper" anchor="#invite" size="lg" @hidden="clearRoute" @shown="trackEventAndFocus" :hide-footer="true" :hide-header="true" :no-enforce-focus="true">
    <div id="content">
      <div class="side-wrapper">
        <h4>Invite team members</h4>
        <form id="invite-form">
          <input type="text" class="email-input" placeholder="Email" id="email" ref="emailInput" v-model="inputEmail"/>
          <input type="submit" class="cloudapp-btn blue" value="Invite" @click="sendInvitation"/>
        </form>
        <p id="success-message" v-if="sentInvitation">
          Invite sent to {{sentInvitation.attributes.email}}
        </p>
        <div id="errors">
          <span v-for="(error, index) in errors" :key="index" class="error">
            {{error.detail}}
            <a :href="`/organizations/${currentOrganization.id}`" target="_blank" v-if="/no more seats/i.test(error.detail)"> here.</a>
          </span>
        </div>
      </div>
      <div class="side-wrapper" id="overview">
        <div id="close">
          <a @click="close()"><i class="fa fa-times"></i></a>
        </div>
        <div id="overview-copy">
          <p>Invited users will have access to shared collections and content limited to the team.</p>
          <p>You can change access at any time, they will be part of your team once they confirm their invitation.</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import track from '@/src/tracking';
import { mapState } from 'vuex';

TimeAgo.addDefaultLocale(en);

export default {
  data: function(){
    return {
      loading: true,
      inputEmail: "",
      sentInvitation: null,
      errors: [],
      inviteSource: "",
    }
  },
  computed: mapState(['currentOrganization']),
  methods: {
    trackEventAndFocus: function(){
      track("viewed_invite_modal", { url: this.$route.fullPath })
      this.$refs.emailInput.focus();
    },
    clearRoute: function(){
      this.$router.push({ path: this.$route.path, hash: null });
    },
    close: function(){
      this.$refs.modalWrapper.$refs.modal.hide();
    },
    timeAgoInWords: function(date){
      const timeAgo = new TimeAgo('en-US');
      return timeAgo.format(new Date(date));
    },
    sendInvitation: function(e){
      e.preventDefault();
      const vm = this;
      const params = {
        organizationId: this.currentOrganization.id,
        params: {
          emails: [this.inputEmail],
          source: this.inviteSource,
        },
      };
      this.$store.dispatch('createInvitation', params)
        .then(function(response) {
          vm.inputEmail = "";
          vm.sentInvitation = response.data.data.invitations[0];
        }).catch(function(err){
          vm.errors = err.response.data.errors;
      })
    },
    setInviteSource: function (e) {
      if (e.target.hash === "#invite") {
        this.inviteSource = e.target.dataset.testid;
      }
    }
  },
  mounted: function () {
    document.addEventListener("click", this.setInviteSource);
  },
}
</script>
<style lang="scss">
  #invite-collaborators-modal___BV_modal_outer_ {
    z-index: 1042 !important;
  }
</style>
<style lang="scss" scoped>
  @import '../../packs/application.scss';

  #content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .side-wrapper {
    display: flex;
    padding: 1rem;
    flex-direction: column;
  }

  #overview {
    background: $dark-blue;
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
    width: 40%;
    color: white;

    #overview-copy {
      margin-top: 30px;
    }
  }

  #close {
    color: white;
    text-align: right;

    a {
      cursor: pointer;
    }
  }

  #invite-form {
    display: flex;
    margin-top: 20px;
  }

  #success-message {
    margin-top: 10px;
  }

  #errors {
    margin-bottom: 20px;

    .error {
      color: $radical-red;
      font-size: 11px;
      display: block;
    }
  }

  .cloudapp-btn {
    border-radius: 5px;
    height: 2rem;
    padding: 0 1rem;
    outline: none;
  }

  .email-input {
    height: 2rem;
    padding: 0.5rem 2.188rem 0.5rem 0.5rem;
    font-size: 0.75rem;
    width: 100%;
    background: $pale-gray;
    border: none;
    border-bottom: 1px $almost-black solid;
    border-radius: 0;
    outline: 0;
    margin-right: 10px;

    &:focus {
      border-bottom: 2px $bright-blue solid;
    }
  }
</style>


<style>
 /* bootstrap-vue parent elements are not really scoped, need to overwrite here */
 #invite-collaborators-modal .modal-body {
   padding: 0;
 }

 #invite-collaborators-modal .modal-content {
   border: none;
  }
</style>